'use client';

import { builder, Builder } from '@builder.io/react';
import './components/basic/WidgetEmbed/WidgetEmbed.registry';
import './components/global/UnderConstruction/UnderConstruction.registry';
import './components/layout/Container/Container.registry';
import './components/layout/Section/Section.registry';
import './components/layout/CsvTable/CsvTable.registry';
import './components/layout/Table/Table.registry';
import './components/ui/Accordion/Accordion.registry';
import './components/ui/AllExperts/AllExperts.registry';
import './components/ui/AppDownload/AppDownload.registry';
import './components/ui/AppDownloadWithForm/AppDownloadWithForm.registry';
import './components/ui/ArticlesList/ArticlesList.registry';
import './components/ui/ArticleSidebar/ArticleSidebar.registry';
import './components/ui/Breadcrumbs/Breadcrumbs.registry';
import './components/ui/Calculator/Calculator.registry';
import './components/ui/ContactCTA/ContactCTA.registry';
import './components/ui/ContactForm/ContactComponent.registry';
import './components/ui/Embed/Embed.registry';
import './components/ui/ExpertQuote/ExpertQuote.registry';
import './components/ui/FeaturedArticles/FeaturedArticles.registry';
import './components/ui/HelpCentreList/HelpCentreList.registry';
import './components/ui/HubFeaturedArticles/HubFeaturedArticles.registry';
import './components/ui/HubNewsCarousel/HubNewsCarousel.registry';
import './components/ui/Hero/Hero.registry';
import './components/ui/Icon/Icon.registry';
import './components/ui/IconCard/IconCard.registry';
import './components/ui/IconCardRow/IconCardRow.registry';
import './components/ui/IconCardsCarousel/IconCardsCarousel.registry';
import './components/ui/ImageCarousel/ImageCarousel.registry';
import './components/ui/LandingPageChecklist/LandingPageChecklist.registry';
import './components/ui/LandingPageForm/LandingPageForm.registry';
import './components/ui/LandingPageHero/LandingPageHero.registry';
import './components/ui/LinkButton/LinkButton.registry';
import './components/ui/PageAlert/PageAlert.registry';
import './components/ui/PageHero/PageHero.registry';
import './components/ui/PageHeroImage/PageHeroImage.registry';
import './components/ui/PartnershipFormPanel/PartnershipFormPanel.registry';
import './components/ui/PaymentsAccepted/PaymentsAccepted.registry';
import './components/ui/PersonCards/PersonCards.registry';
import './components/ui/ProductCards/ProductCards.registry';
import './components/ui/ProductLinks/ProductLinks.registry';
import './components/ui/PromoCTA/PromoCTA.registry';
import './components/ui/RelatedHubs/RelatedHubs.registry';
import './components/ui/ReviewsCarousel/ReviewsCarousel.registry';
import './components/ui/Share/Share.registry';
import './components/ui/ShareCTA/ShareCTA.registry';
import './components/ui/TextImageBlock/TextImageBlock.registry';
import './components/ui/Timeline/Timeline.registry';
import './components/ui/TrustPilot/TrustPilot.registry';
import './components/ui/UsefulGuides/UsefulGuides.registry';
import './components/ui/USPCards/USPCards.registry';
import designTokens from './design-tokens';

builder.init(process.env.NEXT_PUBLIC_BUILDER_API_KEY!);

Builder.register('editor.settings', {
  customInsertMenu: true,
  designTokens: designTokens,
});

Builder.register('insertMenu', {
  name: 'Basic components',
  items: [{ name: 'Image' }, { name: 'Text' }, { name: 'Embed' }, { name: 'WidgetEmbed' }],
});

Builder.register('insertMenu', {
  name: 'Layout components',
  items: [
    { name: 'Box' },
    { name: 'Columns' },
    { name: 'Container' },
    { name: 'Core:Section' },
    { name: 'CsvTable' },
    { name: 'Table' },
  ],
});

Builder.register('insertMenu', {
  name: 'UI components',
  items: [
    { name: 'Accordion' },
    { name: 'AppDownload' },
    { name: 'AppDownloadWithForm' },
    { name: 'ArticlesList' },
    { name: 'ArticleSidebar' },
    { name: 'All Experts' },
    { name: 'Breadcrumbs' },
    { name: 'Calculator' },
    { name: 'ContactComponent' },
    { name: 'ContactCTA' },
    { name: 'EmbedTC' },
    { name: 'ExpertQuote' },
    { name: 'FeaturedArticles' },
    { name: 'HelpCentreList' },
    { name: 'Hero' },
    { name: 'HubFeaturedArticles' },
    { name: 'HubNewsCarousel' },
    { name: 'Icon' },
    { name: 'IconCard' },
    { name: 'IconCardRow' },
    { name: 'IconCardsCarousel' },
    { name: 'ImageCarousel' },
    { name: 'LandingPageChecklist' },
    { name: 'Landingpage Form' },
    { name: 'Landing Page Hero' },
    { name: 'LinkButton' },
    { name: 'PageAlert' },
    { name: 'PageHero' },
    { name: 'PageHeroImage' },
    { name: 'PartnershipFormPanel' },
    { name: 'PaymentsAccepted' },
    { name: 'PersonCards' },
    { name: 'ProductCards' },
    { name: 'ProductLinks' },
    { name: 'PromoCTA' },
    { name: 'RelatedHubs' },
    { name: 'ReviewsCarousel' },
    { name: 'Share' },
    { name: 'ShareCTA' },
    { name: 'TextImageBlock' },
    { name: 'Timeline' },
    { name: 'Trustpilot' },
    { name: 'UsefulGuides' },
    { name: 'USPCards' },
  ],
});

Builder.register('insertMenu', {
  name: 'Global components',
  items: [{ name: 'Footer' }, { name: 'Header' }, { name: 'UnderConstruction' }],
});
